import React, {useEffect, useRef} from "react";
import {observer} from "mobx-react";
import styled from "styled-components";
import {SearchMaskPsoMarketUserOptionsInlineComponent} from "./search-mask-pso-market-user-options-inline.component";
import {IonIcon} from "@ionic/react";
import {checkmarkOutline} from "ionicons/icons";
import {useServices} from "../../../hooks/use-services.hook";
import {MediumButton} from "../../../basic-components/buttons/medium-button";
import {PsoUserOptionsEnum} from "../../../services/flight-search/flight-search-controller/pso.enums";
import {
    IFlightSearchControllerViewModel
} from "../../../services/flight-search/flight-search-controller/flight-search-controller-view-model.interface";
import {ITooltipController, TooltipComponent, TooltipToggleBehaviorEnum} from "../../tooltip/tooltip.component";
import {UserSessionStorageKeys} from "../../../services/storage/user-session-storage/user-session-storage-keys";
import {IPsoMarket} from "../../../services/stations/pso-market.interface";

const ContainerBox = styled.div`
    
`


const PsoButtonBox = styled(MediumButton)`
    position: relative;
    display: flex;
    flex-direction: row;
    gap: ${props => props.theme.spacing.spacing8};
    border-radius: 20px;
    padding: ${props => props.theme.spacing.spacing8} ${props => props.theme.spacing.spacing16};
`

const ToolTipContentBox = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${props => props.theme.spacing.spacing12};
    padding: ${props => props.theme.spacing.spacing8} 
             ${props => props.theme.spacing.spacing16} 
             ${props => props.theme.spacing.spacing12} 
             ${props => props.theme.spacing.spacing16};
`

const PsoButtonCheckmarkBox = styled.span`
    color: ${props => props.theme.colors.primary};
`



interface SearchMaskPsoMarketUserOptionsPopperComponentProps {
    flightSearchController: IFlightSearchControllerViewModel;
    psoMarket: IPsoMarket;
}

export const SearchMaskPsoMarketUserOptionsPopperComponent: React.FC<SearchMaskPsoMarketUserOptionsPopperComponentProps> = observer((props) => {
    const services = useServices();
    const containerRef = useRef<HTMLDivElement | null>(null);
    const searchController =  props.flightSearchController;
    const tooltipControllerRef = useRef<ITooltipController | null>(null);
    const isFirstTime = services.userSessionStorage.getItem(UserSessionStorageKeys.FlightSearchPsoPopperFirstTimeShown) !== 'true';

    useEffect(() => {
        if(isFirstTime) {
            services.userSessionStorage.setItem(UserSessionStorageKeys.FlightSearchPsoPopperFirstTimeShown, 'true');
            tooltipControllerRef.current?.open();
        }
    }, [isFirstTime, services.userSessionStorage]);



    const renderCheckMark = () => {
        if(searchController.psoUserOption === PsoUserOptionsEnum.None) {
            return null;
        }

        return (
            <PsoButtonCheckmarkBox>
                <IonIcon icon={checkmarkOutline}/>
            </PsoButtonCheckmarkBox>
        )
    }


    return (
        <ContainerBox ref={containerRef}>
            <PsoButtonBox>
                <span>{services.language.translate('PSO Route options')}</span>
                {renderCheckMark()}
            </PsoButtonBox>
            <TooltipComponent placement={"top"}
                              targetRef={containerRef}
                              showCloseButton={true}
                              tooltipControllerRef={tooltipControllerRef}
                              toggleBehavior={TooltipToggleBehaviorEnum.OnTargetClick}>
                <ToolTipContentBox>
                    <SearchMaskPsoMarketUserOptionsInlineComponent flightSearchController={searchController} psoMarket={props.psoMarket}/>
                </ToolTipContentBox>

            </TooltipComponent>
        </ContainerBox>
    )
})